{
  "name": "lincoln-literacy-frontend",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve --port 7020",
    "start:mock": "ng serve --configuration=mock --port 7021",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "jest",
    "test:watch": "jest --watch",
    "build:prod": "ng build --configuration production",
    "build:qa": "ng build --configuration qa",
    "serve:prod": "ng serve --configuration production",
    "serve:qa": "ng serve --configuration qa",
    "deploy:prod": "npm run build:prod && node scripts/deploy.js"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^20.3.16",
    "@angular/common": "^20.3.16",
    "@angular/compiler": "^20.3.16",
    "@angular/core": "^20.3.16",
    "@angular/forms": "^20.3.16",
    "@angular/platform-browser": "^20.3.16",
    "@angular/platform-browser-dynamic": "^20.3.16",
    "@angular/router": "^20.3.16",
    "@azure/msal-browser": "4.8.0",
    "@faker-js/faker": "^9.8.0",
    "@langchain/community": "^1.1.10",
    "@langchain/core": "^1.1.18",
    "@mlc-ai/web-llm": "^0.2.80",
    "@primeng/themes": "^20.4.0",
    "@stripe/stripe-js": "^8.5.3",
    "@supabase/supabase-js": "^2.95.3",
    "@tanstack/angular-query-experimental": "^5.90.23",
    "@tanstack/query-async-storage-persister": "^5.90.21",
    "@tanstack/query-core": "^5.90.19",
    "@tanstack/query-persist-client-core": "^5.91.18",
    "@tanstack/query-sync-storage-persister": "^5.90.21",
    "@types/leaflet": "^1.9.21",
    "ag-grid-angular": "^35.0.1",
    "apextree": "^1.3.0",
    "buffer": "^6.0.3",
    "chart.js": "^4.4.8",
    "chartjs-plugin-datalabels": "^2.2.0",
    "idb-keyval": "^6.2.2",
    "langchain": "^1.2.16",
    "leaflet": "^1.9.4",
    "ngx-quill": "^28.0.2",
    "primeflex": "^3.3.1",
    "primeicons": "^7.0.0",
    "primeng": "^20.4.0",
    "quill": "^2.0.3",
    "rxjs": "~7.8.0",
    "socket.io-client": "^4.8.3",
    "tslib": "^2.3.0",
    "zone.js": "~0.15.0"
  },
  "devDependencies": {
    "@angular-builders/jest": "^20.0.0",
    "@angular-devkit/build-angular": "^20.3.15",
    "@angular/cli": "^20.3.15",
    "@angular/compiler-cli": "^20.3.16",
    "@types/jest": "^30.0.0",
    "@types/node": "^22.15.17",
    "@types/quill": "^2.0.14",
    "jest": "^30.0.0",
    "jest-preset-angular": "^16.0.0",
    "msw": "^2.12.7",
    "ts-jest": "^29.4.6",
    "typescript": "~5.9.3"
  },
  "msw": {
    "workerDirectory": [
      "public"
    ]
  }
}
